import React, { useState, useEffect, useContext, useRef } from "react";
import "./AllForVideoH.scss";

import { IComponentVideoH, IComponent} from "../../component.d";
import Player, {getSourceLive} from "../VideoV2/Player";
import { inject, observer } from "mobx-react";
import NoticeQrcode from "../NoticeQrcode";
import { IMedium } from "../../store/VideoStore";
import {getPageSameType} from '../../utils/util';
import VideoManager from '../VideoV2/Manager';

export const shouldShowNotice = (notice: boolean, source: IMedium) => {
  if (Number(notice) && source && source.type == "live") {
    let { source_detail } = source;
    if (
      source_detail &&
      ["wait", "config"].indexOf(source_detail.status) > -1
    ) {
      return true;
    }
  }

  return false;
};

const AllForVideoH = (props: IComponentVideoH) => {
  const {
    rootStore,
    danmuku,
    notice,
    notice_image,
    notice_text,
    cid,
    wrapperStyle,
  } = props;
  const { video_id } = props;
  // 没有依赖导致 会出现更新了video_id不重新获取的问题
  useEffect(() => {
    if(Number(video_id)) {
      rootStore!.videoStore.checkVideoExist(video_id);
    }
  }, [video_id]);

  const [height, setHeight] = useState(210);
  const percent = 1.7777;

  const videoWrapper = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const resizeHandler = () => {
      const theWidth =
        videoWrapper.current?.clientWidth ?
        videoWrapper.current?.clientWidth : 750;
      setHeight(Math.round(theWidth / percent));
    };

    window.addEventListener("resize", resizeHandler);
    resizeHandler();

    // if(window.ResizeObserver) {
    //   const resizeObserver = new ResizeObserver(resizeHandler)
    //   if(videoWrapper && videoWrapper.current) {
    //     resizeObserver.observe(videoWrapper.current);
    //   }
    // }
    let timer = window.setTimeout(resizeHandler, 500);

    return () => {
      // if(videoWrapper && videoWrapper.current) {
      //   resizeObserver.unobserve(videoWrapper.current);
      // }
      window.removeEventListener('resize', resizeHandler);
      window.clearTimeout(timer);
    };
  }, [rootStore!.pagedataStore.renderMode]);

  const source = rootStore!.videoStore.getVideo(video_id) as IMedium;
  useEffect(() => {
    if (source) {
      rootStore.imStore!.addMessageListener(
        "live_video_change",
        (data: any) => {
          let { type, status } = data;
          if (source.source == data.video_id && status == "play") {
            onCountDown();
          }
        }
      );
    }
  }, [source && source.source]);

  const [showNotice, setShowNotice] = useState(false);

  const onCountDown = () => {
    rootStore!.videoStore.checkVideoExist(video_id, true);
  };

  const onException = (isPlay: boolean) => {
    let latestVideo = rootStore!.videoStore.getVideo(video_id);
    if (latestVideo && latestVideo.type == "live") {
      let { source_detail } = latestVideo;
      // 后台设置的是正在直播，但前端检测到没有直播
      if (source_detail.status == "play" && !isPlay) {
        rootStore!.videoStore.updateVideoDetail(video_id, {
          status: "stop",
        });
      }
      if (source_detail.status == "stop" && isPlay) {
        rootStore!.videoStore.updateVideoDetail(video_id, {
          status: "play",
        });
      }
    }
  };

  const onVideoTime = (currentTime: number) => {
    let event = new Event(`video_time_update_${cid}`);
    event.data = currentTime;
    window.dispatchEvent(event);
  };

  const onVideoPLay = ()=>{
    if(props.onVideoPlay) {
      props.onVideoPlay();
    }
  };

  const onVideoPause = ()=>{
    if(props.onVideoPause) {
      props.onVideoPause();
    }
  };

  const bindVideoEvent = (playerId:number | string)=>{
    let instance = VideoManager.getPlayerInstance(String(playerId));
    if(instance) {
      instance.on('play', onVideoPLay);
      instance.on('pause', onVideoPause)
    }
  };

  const onCreated = (playerId:number | string)=>{
    // 监听一下播放和暂停事件
    bindVideoEvent(playerId);

    // 当前组件，是否适用于自动播放
    let videoComponent = [] as IComponent[];
    let canAutoPlay = false;
    getPageSameType(window.pageDetail.template, videoComponent, "videoh");
    if(videoComponent && videoComponent.length == 1) {
      // 并且当前为非直播状态
      if(source && !getSourceLive(source)) {
        canAutoPlay = true;
      }
    }

    if(source && source.status == 'wait') {
      return;
    }

    let seekTime = Number(window.localStorage.getItem(`lastplay_${source.id}`)) || 0;
    let instance = VideoManager.getPlayerInstance(String(playerId));
    if(instance) {
      // 尝试一次自动播放
      const tryAutoPlay = ()=>{
        if(canAutoPlay) {
          let promise = [new Promise((resolve)=>{
            // 目前仅ios支持，Android不支持自动播放
            window.WeixinJSBridge &&
              window.WeixinJSBridge.invoke('getNetworkType', {}, ()=>{
                instance.play();
                window.setTimeout(()=>{
                  instance.seek(seekTime);
                }, 1000);
                resolve(true);
              });

            window.setTimeout(()=>{
              resolve(false)
            }, 2000);
          })];

          Promise.all(promise).then(()=>{
            seekTime ? instance.seek(seekTime) : instance.play();
          });
        }else {
          seekTime ? instance.seek(seekTime) : instance.play();
        }
      };
      tryAutoPlay();
    }
  };

  const finalWrapperStyle = {
    height,
    ...wrapperStyle,
  };
  return (
    <div
      className="all-for-videoh"
      style={finalWrapperStyle}
      ref={videoWrapper}
    >
      {source ? (
        <Player
          key={
            source.id +
            (source.source_detail ? source.source_detail.status : "")
          }
          autoPlay={true}
          source={source}
          danmuku={danmuku}
          rootStore={rootStore}
          onCountDown={onCountDown}
          onException={onException}
          onVideoTime={onVideoTime}
          onCreated={onCreated}
        />
      ) : null}

      {shouldShowNotice(notice, source) ? (
        <NoticeQrcode
          videoid={Number(source && source.id)}
          image={notice_image}
          text={notice_text}
        />
      ) : null}
    </div>
  );
};

export default inject("rootStore")(observer(AllForVideoH));
